import ArtifactList from './ArtifactList';

type BuildArtifactListProps = {
  appSlug: string;
  buildSlug: string;
  triggeredWorkflow: string;
  isRunning: boolean;
};

const BuildArtifactList = ({ appSlug, buildSlug, triggeredWorkflow, isRunning }: BuildArtifactListProps) => (
  <ArtifactList
    appSlug={appSlug}
    buildSlug={buildSlug}
    triggeredWorkflow={triggeredWorkflow}
    pipelineSlug={undefined}
    attemptId={undefined}
    isRunning={isRunning}
  />
);

export default BuildArtifactList;
